import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import FileViewer from '../../FileViewer';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
import logo from '../../assets/LideresenMovimiento.png';
import routes from '../../../routers/routes';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const Logo = styled('img')({
  maxHeight: '36px',
  objectFit: 'contain',
});

export default function ModalMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  let navigate = useNavigate();
  const [openViewer, setOpenViewer] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);

  const handleSelectFile = () => {
    setSelectedFile({
      label: 'Aviso de Privacidad',
      src: 'https://s3.amazonaws.com/lideresenmovimiento.s3/Aviso+de+Privacidad.pdf',
      type: 'PDF',
    });
    setOpenViewer(true);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (route) => {
    navigate(route);
    setAnchorEl(null);
  };

  const handleGoToLogin = () => {
    window.open('https://lem.learnala.com/login', '_blank');
  };

  const items = [
    { label: 'Inicio', route: routes.root },
    // { label: 'Líderes en Movimiento Media Superior', route: routes.lemMS },
    { label: 'Conoce más sobre LeM U', route: routes.lemU },
    { label: 'Repositorio', route: routes.repositorio },
    { label: 'Contacto', route: routes.contacto },
  ];

  return (
    <div>
      <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleClick}>
        <MenuIcon />
      </IconButton>
      <Drawer
        transitionDuration={{ enter: 400, exit: 200 }}
        open={open}
        onClose={handleClose}
        anchor="right"
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        sx={{
          '& .MuiDrawer-paper': { right: 0, left: 0, backgroundColor: 'transparent' },
        }}
      >
        <Stack
          sx={{
            backgroundColor: '#268c83e8',
            color: 'white',
            height: '100%',
            px: { xs: 2, sm: 3 },
            flexGrow: 1,
          }}
        >
          <Stack flexGrow={1}>
            <Stack flexGrow={1}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ height: 48, mb: 2 }}
              >
                <Logo src={logo} alt="Líderes en Movimiento Logo" />
                <IconButton edge="start" color="inherit" onClick={handleClose} sx={{ mr: 2 }}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              {items.map((item) => (
                <MenuItem
                  key={item.label}
                  // component={Link}
                  tabIndex={0}
                  role="menuitem"
                  onClick={() => handleClose(item.route)}
                  sx={{
                    placeContent: 'center',
                    fontSize: '1.25rem',
                    whiteSpace: 'normal',
                    textAlign: 'center',
                  }}
                >
                  {item.label}
                </MenuItem>
              ))}
              <Button
                variant="contained"
                onClick={handleGoToLogin}
                sx={{
                  alignSelf: 'center',
                  backgroundColor: '#fac147',
                  color: 'black',
                  '&:hover': {
                    backgroundColor: '#db9b10',
                  },
                }}
              >
                ¿Ya empezaste tu aplicación? Continua Aquí
              </Button>
            </Stack>
            <Stack direction="row" spacing={1} p={2} justifyContent="center" sx={{ opacity: 0.7 }}>
              <span>@Líderes en Movimiento</span>
              <span>|</span>
              <span>Todos Los Derechos Reservados</span>
              <span>|</span>
              <Box sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={handleSelectFile}>
                Aviso de Privacidad
              </Box>
              {openViewer && (
                <FileViewer
                  open={openViewer}
                  setOpen={setOpenViewer}
                  src={selectedFile.src}
                  label={selectedFile.label}
                  type={selectedFile.type}
                />
              )}
            </Stack>
          </Stack>
        </Stack>
      </Drawer>
    </div>
  );
}
